import React from 'react';

const LegalPage = ({ title, intro, lastUpdated = '18 July 2026', children }) => (
  <div className="bg-surface min-h-full px-6 py-12 md:py-16">
    <article className="legal-card">
      <header className="border-b border-ink/10 pb-6 mb-8">
        <p className="text-sm font-semibold text-violet">Lokyis Ltd</p>
        <h1 className="text-3xl md:text-4xl font-bold text-ink mt-2">{title}</h1>
        <p className="text-sm text-ink/55 mt-3">Last updated: {lastUpdated}</p>
        {intro && <p className="text-base text-ink/70 leading-relaxed mt-5">{intro}</p>}
      </header>
      <div className="legal-content">{children}</div>
    </article>
  </div>
);

export default LegalPage;
